export default () => {
    if ($('.form-simple-popup').length === 0) {
        return;
    }

    $('.form-simple-open').click(function (e) {
        $('#form-simple-popup').show();
    })

    $('.close-btn').click(function (e) {
        $('#form-simple-popup').hide();
    });
}